import { Component, Injector } from '@angular/core';
import { DisplayableContentContainerComponent } from '../../../../../shared/components/displayable-content/displayable-content-container/displayable-content-container.component';
import { NavigationService } from '../../../../../../services/navigation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionService } from '../../../../../../services/action.service';
import { WebTemplatesContainerViewModel } from './web-templates-container-view-model';
import { DisplayableContentContainerViewModel } from '../../../../../shared/components/displayable-content/displayable-content-container/displayable-content-container-view-model';

@Component({
  selector: 'app-web-templates-container',
  templateUrl:
    '../../../../../shared/components/displayable-content/displayable-content-container/displayable-content-container.component.html',
  styleUrls: [
    '../../../../../shared/components/displayable-content/displayable-content-container/displayable-container.component.scss',
    './web-templates-container.component.scss'
  ],
  providers: [{ provide: DisplayableContentContainerViewModel, useExisting: WebTemplatesContainerViewModel }],
  standalone: false
})
export class WebTemplatesContainerComponent extends DisplayableContentContainerComponent {
  constructor(
    public override viewModel: WebTemplatesContainerViewModel, // Provided by Logged In Scope
    navigationService: NavigationService,
    ngbModal: NgbModal,
    injector: Injector,
    actionService: ActionService
  ) {
    super(viewModel, navigationService, ngbModal, injector, actionService);
  }
}
